export default {
  emptyState: "No events to show at this time"
};
